// Clases de los campos compactos de Comisiones, como los paneles de filtros del portal.
export const LABEL =
    'mb-[5px] block text-[9.5px] font-bold uppercase tracking-[0.08em] text-muted-foreground';
export const FIELD =
    'h-[28px] w-full rounded-md border border-input bg-transparent px-2 text-[11.5px] outline-none focus-visible:border-ring disabled:opacity-60';
export const SECTION_TITLE =
    'mb-2 text-[10px] font-bold uppercase tracking-[0.08em] text-muted-foreground';
export const FIELD_ERROR = 'mt-1 text-[10.5px] text-destructive';
